import { gettext } from '@eventbrite/i18n';
import { Icon } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import {
    getHeapDataAttribute,
    HeapAttributes,
} from '../../../../../utils/heap-data';
import { navigationLinkProps } from '../../../../types';
import styles from './NavLink.module.scss';

const NavLink = ({
    path,
    heapIdentifier,
    translatedText,
    textColor,
    iconType,
    iconPosition,
    className,
}: navigationLinkProps) => {
    const navLinkClass = classNames(styles.main, className);
    const iconPositionClass = iconPosition === 'right' ? styles.iconRight : '';
    const { Teams, Features, Components, Actions } = HeapAttributes;

    return (
        <a
            className={navLinkClass}
            href={path}
            data-testid="navLink"
            aria-label={gettext('link')?.toString()}
            data-heap-id={getHeapDataAttribute({
                team: Teams.SEO,
                feature: Features.GlobalNav,
                component: Components.Link,
                name: heapIdentifier.replaceAll(' ', '-').toLowerCase(),
                action: Actions.Click,
            })}
        >
            {!!iconType && (
                <span data-testid="navLink-icon" className={iconPositionClass}>
                    <Icon>
                        <>{iconType}</>
                    </Icon>
                </span>
            )}
            <span style={{ color: textColor }}>{translatedText}</span>
        </a>
    );
};

export default NavLink;
